import { css } from '@emotion/core'
import { colors } from '@bonitour/components'

export const wrapperTotal = css`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  border-radius: 0.625rem;
  background-color: ${colors.white};
  padding: 1.25rem 1rem;
  border: 0.0625rem solid ${colors.gray8};
  height: 100%;
  white-space: nowrap;
  width: 14.75rem;
  margin-bottom: 1.25rem;
  box-sizing: border-box;

  .total__label {
    color: ${colors.gray3};
    font-size: 1rem;
  }
  .total__number {
    color: ${colors.gray1};
    font-weight: 700;
    font-size: 1.1875rem;
  }
  
  @media(max-width: 28.125rem) {
    width: 100%;
  }
`
